export default {
      id: "search-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#search",
      toString: function () {
        return this.url;
      }
    }